import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { Hoverable, Text } from '../../uiold';

import { themeColors } from '../../uiold/Constants';
import { HoverFieldType } from '../types';

function HorizontalCardSquare(props: {
  imageUrl: string;
  name: string;
  description: string;
  hoverFieldType?: HoverFieldType | null;
  nameColor: string;
  descriptionColor: string;
  backgroundColor: string;
}) {
  let {
    hoverFieldType,
    imageUrl,
    name,
    description,
    nameColor,
    descriptionColor,
    backgroundColor,
  } = props;

  return (
    <Hoverable
      render={(isHovered, eventHandlers) => {
        return (
          <View
            style={[
              styles.flexRow,
              styles.root,
              isHovered ? styles.rootHover : null,
              { backgroundColor },
            ]}
            {...eventHandlers}
          >
            <View
              style={
                hoverFieldType === 'card'
                  ? [styles.hoverCardBorder, styles.hoverBorder]
                  : null
              }
            />
            <View
              style={
                hoverFieldType === 'image'
                  ? [styles.hoverImageBorder, styles.hoverBorder]
                  : null
              }
            />
            <Image
              source={{
                uri: imageUrl ? imageUrl : '/assets/images/placeholder.png',
              }}
              resizeMode="cover"
              style={styles.image}
            />
            <View style={styles.content}>
              <View
                style={
                  hoverFieldType === 'name'
                    ? [styles.hoverNameBorder, styles.hoverBorder]
                    : null
                }
              />
              <Text
                style={
                  hoverFieldType === 'name' ? styles.nameInfo : styles.blank
                }
              >
                {t('34 Character Limit')}
              </Text>
              <Text
                numberOfLines={2}
                style={{
                  fontSize: 16,
                  fontWeight: '600',
                  marginVertical: 5,
                  color: nameColor,
                }}
              >
                {name ?? ''}
              </Text>
              <Text
                style={
                  hoverFieldType === 'description'
                    ? styles.descriptionInfo
                    : styles.blank
                }
              >
                {t('130 Character Limit')}
              </Text>
              <View
                style={
                  hoverFieldType === 'description'
                    ? [styles.hoverDescriptionBorder, styles.hoverBorder]
                    : null
                }
              />
              <Text
                numberOfLines={6}
                style={{
                  fontSize: 12,
                  fontWeight: '300',
                  marginTop: 2,
                  color: descriptionColor,
                }}
              >
                {description ?? ''}
              </Text>
            </View>
          </View>
        );
      }}
    />
  );
}

let styles = StyleSheet.create({
  root: {
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.grey,
    borderRadius: 5,
    backgroundColor: themeColors.white,
    width: 340,
    height: 160,
  },
  rootHover: {
    shadowColor: themeColors.black,
    shadowOffset: { width: 5, height: 5 },
    shadowRadius: 12,
    shadowOpacity: 0.3,
  },
  image: {
    width: 130,
    height: '100%',
    padding: 0,
    margin: 0,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
  },
  hoverBorder: {
    position: 'absolute',
    borderWidth: 4,
    borderColor: themeColors.blue,
    borderRadius: 5,
  },
  hoverCardBorder: {
    left: -10,
    top: -10,
    width: 360,
    height: 180,
  },
  hoverImageBorder: {
    left: -10,
    top: -10,
    width: 150,
    height: 180,
  },
  blank: { display: 'none' },
  hoverNameBorder: {
    left: 0,
    top: 2,
    width: 200,
    height: 42,
  },
  nameInfo: {
    position: 'absolute',
    left: 10,
    top: -20,
    color: themeColors.blue,
  },
  hoverDescriptionBorder: {
    left: 0,
    top: 38,
    width: 200,
    height: 118,
  },
  descriptionInfo: {
    position: 'absolute',
    left: 10,
    top: 160,
    color: themeColors.blue,
  },
  flexRow: {
    flexDirection: 'row',
  },
  content: {
    flexDirection: 'column',
    width: 210,
    paddingHorizontal: 12,
    paddingVertical: 5,
    height: '100%',
  },
});

export default HorizontalCardSquare;
